import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import languageHelper from 'helpers/languages';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderAutoCompleteInputField from 'components/form/InputFields/RenderAutoCompleteInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';

class UsersEditForm extends React.Component {
    componentDidMount() {
        const { data, initialize } = this.props;

        initialize(data);
    }

    componentDidUpdate(prevProps) {
        const prevData = prevProps.data;
        const { data } = this.props;

        if (utils.get(prevData, 'id') !== utils.get(data, 'id')) {
            const { initialize } = this.props;

            initialize(data);
        }
    }

    render() {
        const {
            data,
            handleSubmit,
            handleSubmitForm,
            submitting,
            translate,
        } = this.props;

        const {
            config: {
                language: {
                    supported: supportedLanguages,
                },
            },
        } = this.context;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.users.forms.general') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.firstname') }
                                    name='first_name'
                                    validate={ validations.required }
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.lastname') }
                                    name='last_name'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    choices={ languageHelper.getLanguageChoices(supportedLanguages, translate) }
                                    component={ RenderAutoCompleteInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.locale') }
                                    name='locale'
                                    optionText='label'
                                    optionValue='value'
                                    startingValue= { data.locale }
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.users.forms.contact') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ true }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.email') }
                                    name='email'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.phonenumber') }
                                    name='phone'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

UsersEditForm.contextTypes = {
    config: PropTypes.object,
};

UsersEditForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm(),
);

export default enhance(UsersEditForm);



// WEBPACK FOOTER //
// ./src/pages/users/edit/UsersEditForm.js